import { defineComponent as _defineComponent } from 'vue'
import { withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { h, useSlots, reactive } from "vue";
      import { assignSlotNodes, Slots } from "@lit-labs/vue-utils/wrapper-utils.js";
      import '@oicl/openbridge-webcomponents/dist/components/sequence-step/sequence-step.js';
      import {SequenceOrientation, SequenceType, SequenceStyle, SequenceValue, SequenceVariant} from '@oicl/openbridge-webcomponents/dist/components/sequence-step/sequence-step.js';

      export interface Props {
     orientation?: SequenceOrientation;
     type?: SequenceType;
     styleType?: SequenceStyle;
     value?: SequenceValue;
     variant?: SequenceVariant | undefined;
     hasIcon?: boolean;
     showStepInputConnector?: boolean;
     showStepOutputConnector?: boolean;
     inputConnectorExtended?: boolean
   }

      
  
      export type {SequenceOrientation, SequenceType, SequenceStyle, SequenceValue, SequenceVariant} from '@oicl/openbridge-webcomponents/dist/components/sequence-step/sequence-step.js';
    
export default /*@__PURE__*/_defineComponent({
  __name: 'ObcSequenceStep',
  props: {
    orientation: {},
    type: {},
    styleType: {},
    value: {},
    variant: {},
    hasIcon: { type: Boolean },
    showStepInputConnector: { type: Boolean },
    showStepOutputConnector: { type: Boolean },
    inputConnectorExtended: { type: Boolean }
  },
  setup(__props: any) {

      const vueProps = __props;

  const defaults = reactive({} as Props);
  const vDefaults = {
    created(el: any) {
      for (const p in vueProps) {
        defaults[p as keyof Props] = el[p];
      }
    }
  };

  let hasRendered = false;

      

      const slots = useSlots() as Slots;

      const render = () => {
        const eventProps = {
    
  };
        const props = eventProps as (typeof eventProps & Props);

        
      for (const p in vueProps) {
        const v = vueProps[p as keyof Props];
        if ((v !== undefined) || hasRendered) {
          (props[p as keyof Props] as unknown) = v ?? defaults[p as keyof Props];
        }
      }

      hasRendered = true;
    

        return h(
          'obc-sequence-step',
          props,
          assignSlotNodes(slots)
        );
      };
    
return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createBlock(render, null, null, 512)), [
    [vDefaults]
  ])
}
}

})